// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__UsEeS","left":"InfoRow_left__3g-E9"};